import { lazy, Suspense } from "react";
import { LazyLoadingAnimation } from "./Lazy";
import { ReactJsonViewProps } from "react-json-view";
import { ErrorCatch } from './ErrorCatch';
const ReactJson = lazy(() => import("react-json-view"));

export var ReactJsonView = (props: ReactJsonViewProps) => {
    return (
        <ErrorCatch>
            <Suspense fallback={<LazyLoadingAnimation style={{ width: "100%", height: "100%", backgroundColor: "#1e1e1e" }} />}>
                <ReactJson {...props} />
            </Suspense>
        </ErrorCatch>
    );
}